import { api } from '../store/api';

export interface ApiStatisticsFilters {
  date?: string;
}

export interface ApiError {
  request_id: string;
  timestamp: string;
  method: string;
  url: string;
  status_code: number;
  response_size: number;
  api_key: string;
}

export interface ApiStatisticsResponse {
  date: string;
  total_requests: number;
  methods: Record<string, number>;
  status_codes: Record<string, number>;
  endpoints: Record<string, number>;
  ip_addresses: Record<string, number>;
  api_keys: Record<string, number>;
  average_response_time_ms: number;
  error_count: number;
  errors: ApiError[];
}

export const apiStatisticsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getApiStatistics: builder.query<ApiStatisticsResponse, ApiStatisticsFilters>({
      query: (filters) => ({
        url: '/api-statistics',
        method: 'GET',
        params: filters,
      }),
    }),
  }),
});

export const { useGetApiStatisticsQuery } = apiStatisticsApi; 